import { RequestConfig } from '~/common/services/requests';
import { InceptHeader } from '../../../../../api';
import { ENVIRONMENT } from '../../../../../constants';
import { TenantedApplicationConfig } from '../../../../tenantedApplicationConfig';

export const makeTenantedConfig = (
  config: RequestConfig,
  _tenantConfig: TenantedApplicationConfig,
) => ({
  ...config,
  baseURL: ENVIRONMENT.apiUrl,
  headers: {
    ...config.headers,
    [InceptHeader.Timezone]: Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});
